import ReactModal from "react-modal";
import "./modalStyle.css";
interface RightSideModalProps {
  isOpen: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  className?: string;
  wrapperClassName?: string;
  showMobileCancelButton?: boolean;
}

const RightSideModal: React.FC<RightSideModalProps> = ({
  isOpen,
  onClose,
  children,
  wrapperClassName,
  className,
  showMobileCancelButton = true,
}) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      closeTimeoutMS={200}
      className={`${className} fixed inset-y-0 right-0 z-50 ml-auto h-full w-full max-w-full bg-white shadow-2xl outline-none sm:w-[440px] sm:max-w-[440px] md:w-[500px] md:max-w-[500px] lg:w-1/3 lg:max-w-[520px] ${wrapperClassName}`}
      overlayClassName="fixed z-50 inset-0 bg-black/40"
    >
      <div className="min-h-full flex flex-col">
        <div className="flex-1 overflow-y-auto pb-16 sm:pb-0">{children}</div>

        {/* Mobile-only close action for better UX */}
        {showMobileCancelButton && (
          <div className="sm:hidden sticky bottom-0 z-10 border-t border-gray-200 bg-white p-4">
            <button
              type="button"
              onClick={onClose}
              className="w-full h-[44px] rounded-md border border-[#A4A4A4] bg-white text-[#1C1C1C] font-Open font-semibold text-[14px] inline-flex items-center justify-center text-center select-none appearance-none hover:bg-[#F6F6F6] active:bg-[#EDEDED] focus:outline-none focus:ring-2 focus:ring-[#004EFF]/20"
            >
              Cancel
            </button>
          </div>
        )}
      </div>
    </ReactModal>
  );
};

export default RightSideModal;
